import React from 'react';
import { Route, Routes } from 'react-router';
import { Navigate } from 'react-router-dom';
import { AppConfig } from '../../app/AppConfig';
import { CookieInfoLayer } from './legal/CookieInfoLayer';
import { DataProtectionNotice } from './legal/DataProtectionNotice';
import { StatementOnTheUseOfCookies } from './legal/StatementOnTheUseOfCookies';

const PagesRoutes = () => {
  const PageRoutes = AppConfig.pages.map((page, index) => {
    return <Route path={page.url} element={page.component} key={index} />;
  });

  const HomeSubPagesRoutes = AppConfig.homeSubPages.map(
    (homeSubPage, index) => {
      return (
        <Route
          path={homeSubPage.url}
          element={homeSubPage.component}
          key={index}
        />
      );
    }
  );

  return (
    <>
      <Routes>
        {PageRoutes}
        {HomeSubPagesRoutes}
        <Route path='/cookie' element={<CookieInfoLayer />} />
        <Route path='/dpnotice' element={<DataProtectionNotice />} />
        <Route path='/cookiesuse' element={<StatementOnTheUseOfCookies />} />
        <Route
          path='*'
          element={<Navigate to={AppConfig.defaultRoute} replace={true} />}
        />
      </Routes>
    </>
  );
};

export { PagesRoutes };
